/**
 * useStoreData.js — React hook for subscribing to dataStore keys.
 *
 * Usage:
 *   const odds = useStoreData('odds');           // returns array (auto-converted from Map)
 *   const arbs = useStoreData('arbitrage');       // returns array
 *   const lastUpdate = useStoreData('lastUpdate'); // returns Date or null
 *
 * The component only re-renders when the specific key it subscribes to
 * changes — not when unrelated keys change.
 */

import { useState, useEffect, useMemo, useTransition } from 'react';
import dataStore from './dataStore';

export function useStoreData(key) {
  const [version, setVersion] = useState(0);
  const [, startTransition] = useTransition();

  useEffect(() => {
    return dataStore.subscribe(key, () => {
      startTransition(() => {
        setVersion(v => v + 1);
      });
    });
  }, [key]);

  return useMemo(() => {
    const data = dataStore.get(key);
    if (data instanceof Map) {
      return Array.from(data.values());
    }
    return data;
  }, [key, version]);
}